module.exports = __webpack_public_path__ + "static/media/warning.5ea7a30f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warning.svg
// module id = 1443
// module chunks = 0